let regimes = [
  { value: 'R', label: 'REGIME NORMAL' },
  { value: 'S', label: 'SIMPLES NACIONAL' },
]

export default regimes
